export const getCurrentYear = () => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  if (currentMonth < 8) {
    return `${currentYear - 1}-${currentYear}`;
  }
  return `${currentYear}-${currentYear + 1}`;
};

const getAcademicYears = () => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  // between april and august
  if (currentMonth > 3 && currentMonth < 8) {
    return [
      `${currentYear}-${currentYear + 1}`,
      `${currentYear - 1}-${currentYear}`,
      `${currentYear - 2}-${currentYear - 1}`,
    ];
  }
  // after september
  if (currentMonth >= 8) {
    return [`${currentYear}-${currentYear + 1}`, `${currentYear - 1}-${currentYear}`];
  }
  // january to march
  return [`${currentYear - 1}-${currentYear}`, `${currentYear - 2}-${currentYear - 1}`];
};

export const ACADEMIC_YEARS = getAcademicYears();
export const CAMPUSES = ["Saclay", "Metz", "Rennes"];
export const CAMPUSES_DISPLAY = ["Paris Saclay", "Metz", "Rennes"];
export const SEMESTERS = ["S5", "S6", "S7", "S8", "S9", "S10"];
